import { Component, Input, OnChanges, ViewChild, HostListener } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/authService/authentication.service';
import { ApplicationStateService } from 'src/app/core/services/applicationState/application-state.service';
import { UserRoles, WindowSize } from 'src/app/data/models';
import { MenuComponent, MenuEventArgs, MenuItemModel, SidebarComponent, TreeViewComponent } from '@syncfusion/ej2-angular-navigations';
import { Router } from '@angular/router';
import { LeftNavigationService } from '../../services/left-navigation.service';
import { ManageInformationLinksPaginationService } from 'src/app/modules/settings/information-links/information-links.service';
import { LocalconstService } from 'src/app/core/services/localConst/localconst.service';
import { UserPermissionService } from 'src/app/core/services/userPermission/user-permission.service';
import { GlobalConstants } from '../../services/constants/globalconstants';

@Component({
    selector: 'app-left-navigation',
    templateUrl: './left-navigation.component.html',
    styleUrls: ['./left-navigation.component.scss'],
    standalone: false
})
export class LeftNavigationComponent implements OnChanges {
  @ViewChild('sidebar') sidebar: SidebarComponent;
  @ViewChild('sidebarTreeviewInstance')
  public sidebarTreeviewInstance: SidebarComponent;
  public defaultSidebarHidenForLmsAdmin = false;
  isEmailTemplete: boolean;
  @ViewChild('treeView')
  public tree: TreeViewComponent;
  private selectedSubMenu = '';
  private selectedMenu = '';
  private selectedMenuRespond = '';

  @ViewChild('menuObj') private menuObj: MenuComponent;

  settingsSubMenu: MenuItemModel[] = [];
  public menuItems: MenuItemModel[] = [];
  public enableGestures = false;
  public target = '#sidebar-section';
  public swidth = '90px';
  public sswidth = '232px';
  public mediaQuery: object = window.matchMedia('(min-width: 90px)');
  public dockSize = '90px';
  public mstype = 'Push';

  @Input('openCloseSideBar') IsOpenCloseSideBarTriggred: any;
  currentUser: any;
  respondUser: any;
  isSideBarCollapsed = false;
  isIncidentReportCollapsed = true;
  isSettingsCollapsed = true;
  windowSize: WindowSize;
  private isMenuClicked = false;

  constructor(private authService: AuthenticationService,
    private applicationStateService: ApplicationStateService, private router: Router,
    private leftNavService: LeftNavigationService,
    private localConst: LocalconstService,
    public userPermissionService: UserPermissionService,
    private ManageInfoLinksPaginationService: ManageInformationLinksPaginationService) {
    this.authService.currentUser.subscribe(user => this.currentUser = user);
    this.authService.respondUser.subscribe(respondUser => this.respondUser = respondUser);
    this.applicationStateService.windowSizeChanged.subscribe(x => {
      this.windowSize = x;
      if (this.windowSize != undefined && this.windowSize.isMobile) {
        this.isIncidentReportCollapsed = true;
        this.isSettingsCollapsed = true;
      }
    });

    this.leftNavService.getMenuItemToBeUpdated().subscribe((activeMenuID: string) => {
      this.setActiveMenuByID(activeMenuID);
    });
  }

  ngOnInit() {
    this.userPermissionService.bindMenuItems(this.currentUser);
  }

  ngOnChanges() {
    if (this.IsOpenCloseSideBarTriggred != undefined) {
      //this.openCloseSidebar();
    }
  }

  onCreated(Event: any): void {
    //Default to incident report
    let navigateTo = localStorage.getItem('currentSelectedNode') || 'INCREP';
    if (navigateTo === 'Dashboard') {
      navigateTo = 'INCREP';
      localStorage.setItem('currentSelectedNode', "INCREP");
    }
    if (this.defaultSidebarHidenForLmsAdmin) {
      if (this.sidebarTreeviewInstance) {
        this.sidebarTreeviewInstance.hide();
        this.sidebarTreeviewInstance.element.style.visibility = 'visible';
      }
    }

    const isUserOfTypeCMS = !GlobalConstants.RespondRoutes.includes(this.router.url);
    const anonymousdialogueUrl = `${'/'}${GlobalConstants.RespondRouteAnonymousDialogue}`;
    let selectedRespondNode = 'respondAnonymousDialog';
    if (this.router.url != anonymousdialogueUrl) {
      selectedRespondNode = this.router.url === `${'/'}${GlobalConstants.RespondRouteAddUpdateUserEmail}` ? 'addupdateuseremail' : 'changesigninpin';
    }

    navigateTo = isUserOfTypeCMS ? navigateTo : selectedRespondNode;

    for (let i = 0; i < this.menuObj.element.children.length; i++) {
      if (this.menuObj.element.children[i].id === navigateTo) {
        this.menuObj.element.children[i].classList.add('e-active');
      }
      else {
        this.menuObj.element.children[i].classList.remove('e-active');
      }
    }
    this.leftNavService.setScopeLeftNavigation(this.menuObj);
  }


  onMenuEj2Select(e: MenuEventArgs): void {
    const isUserOfTypeCMS = !GlobalConstants.RespondRoutes.includes(this.router.url);
    if (isUserOfTypeCMS) {
      this.selectedMenu = e.item.id;
      localStorage.setItem('currentSelectedNode', e.item.id as string);
    }
    else {
      this.selectedMenuRespond = e.item.id;
    }

    switch (e.item.id) {
      case 'Dashboard':
        this.selectedSubMenu = '';
        this.router.navigate(['/dashboard']);
        break;
      case 'Users':
        this.selectedSubMenu = '';
        this.router.navigate(['/userlist']);
        break;
      case 'LCT':
        this.selectedSubMenu = '';
        this.router.navigate(['/location']);
        break;
      case 'DVS':
        this.selectedSubMenu = '';
        this.router.navigate(['/division']);
        break;
      case 'ITY':
        this.selectedSubMenu = '';
        this.router.navigate(['/incidentTypes']);
        break;
      case 'MDBAS':
        localStorage.setItem('currentSelectedNode', 'ST');
        this.selectedMenu = 'ST';
        this.selectedSubMenu = 'MDBAS';
        this.router.navigate(['/dbas']);
        break;
      case 'INCREP':
        this.selectedSubMenu = '';
        localStorage.setItem('currentSelectedNode', 'INCREP');
        this.router.navigate(['/incidentreport']);
        break;
      case 'MET':
        localStorage.setItem('currentSelectedNode', 'ST');
        this.selectedMenu = 'ST';
        this.selectedSubMenu = 'emailTemplates';
        this.router.navigate(['/emailtmpls']);
        break;
      case 'META':
        localStorage.setItem('currentSelectedNode', 'ST');
        this.selectedMenu = 'ST';
        this.selectedSubMenu = 'emailTemplates';
        this.router.navigate(['/emailtmpls/assign']);
        break;
      case 'MCC':
        localStorage.setItem('currentSelectedNode', 'ST');
        this.selectedMenu = 'ST';
        this.selectedSubMenu = '';
        this.router.navigate(['']);
        break;
      case 'ST':
        this.selectedSubMenu = '';
        this.router.navigate(['/settingslist']);
        break;
      case 'ACTIONITEM':
        this.selectedSubMenu = '';
        this.router.navigate(['/actionitems']);
        break;
      case 'INBOX':
        this.selectedSubMenu = '';
        this.router.navigate(['/inbox']);
        break;
      case 'InfoLinks':
        this.selectedSubMenu = '';
        this.router.navigate([`/${GlobalConstants.InformationLinksRoute}`]);
        break;
      case 'analytics':
        this.selectedSubMenu = '';
        this.router.navigate(['/analytics']);
        break;
      case 'respondAnonymousDialog':
        this.selectedSubMenu = '';
        this.router.navigate(['/anonymousdialogue']);
        break;
      case 'changesigninpin':
        this.selectedSubMenu = '';
        this.router.navigate(['/changesigninpin']);
        break;
      case 'addupdateuseremail':
        this.selectedSubMenu = '';
        this.router.navigate(['/addupdateuseremail']);
        break;
    }
    this.setActiveMenu();
  }

  setActiveMenu() {
    const isUserOfTypeCMS = !GlobalConstants.RespondRoutes.includes(this.router.url);
    let index = 0;
    for (let i = 0; i < this.menuObj.element.children.length; i++) {
      this.menuObj.element.children[i].classList.remove('e-active');
      if (isUserOfTypeCMS) {
        if (this.menuObj.element.children[i].id === this.selectedMenu) {
          index = i;
        }
      }
      else {
        if (this.menuObj.element.children[i].id === this.selectedMenuRespond) {
          index = i;
        }
      }
    }
    this.menuObj.element.children[index].classList.add('e-active');
  }

  setActiveMenuByID(activeMenuID: string) {
    let currentActiveMenu = -1;
    let newActiveMenu = -1;

    for (let i = 0; i < this.menuObj.element.children.length; i++) {
      if (this.menuObj.element.children[i].classList.contains('e-active'))
      {
        currentActiveMenu = i;
        this.menuObj.element.children[i].classList.remove('e-active');
      }

      if (this.menuObj.element.children[i].id === activeMenuID) {
        newActiveMenu = i;
        this.menuObj.element.children[i].classList.add('e-active');
      }
    }

    if (newActiveMenu == -1)
      this.menuObj.element.children[currentActiveMenu].classList.add('e-active');
  }

  logoutLink() {
    this.authService.logout();
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    if (this.isEmailTemplete) {
      this.isEmailTemplete = false;
    }
    else {
      if ((targetElement as HTMLElement).parentElement != null && (targetElement as HTMLElement).parentElement.id == 'treeView_active') {
      } else if (this.isMenuClicked) {
        this.isMenuClicked = false;
      }
    }
  }

  public onCancelProfile() {
    this.menuObj = this.leftNavService.getScopeLeftNavigation();
    for (let i = 0; i < this.menuObj.element.children.length; i++) {
      this.menuObj.element.children[i].classList.remove('e-active');
    }
    const isUserOfTypeCMS = !GlobalConstants.RespondRoutes.includes(this.router.url);
    const indexToSetActive = isUserOfTypeCMS ? 'INCREP' : 'respondAnonymousDialog';
    this.menuObj.element.children[indexToSetActive].classList.add('e-active');
  }
  
  onBeforeItemRender(e: MenuEventArgs) {
    const selectedNode = localStorage.getItem('currentSelectedNode');
    if (e.item.id == selectedNode) {
      e.element.classList.add('e-active');
    }
  }
}
